import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackAccreditedBanksToListingClick } from '../../analytics/promos';
import { AccreditedBanks } from '../../components/AccreditedBanks';

import { IBank } from '../../types/newbuilding/bank';
import { banksSelector, newbuildingIdSelector } from '../../selectors';

export const AccreditedBanksContainer: React.FC = () => {
  const banks = useSelector(banksSelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const handleBankClick = React.useCallback(
    (bank: IBank) => {
      trackAccreditedBanksToListingClick(bank, newbuildingId);
    },
    [newbuildingId],
  );

  return <AccreditedBanks banks={banks} onBankClick={handleBankClick} />;
};
